<template>
  <BaseButton success outline small class="flex-auto" @click="onManageReviews">
    Manage reviews
  </BaseButton>
</template>

<script>
export default {
  props: {
    projectAsset: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onManageReviews() {
      this.$modal.show({
        component: () => import('Components/ProjectAssets/ManageReviewsModal.vue'),
        props: {
          projectAssetId: this.projectAsset.id,
        },
        on: {},
        hideEvent: 'close',
      });
    },
  },
};
</script>
